import { useEffect, useRef } from 'react';
import { Engine } from '@/enthea/lib/engine';
import { useStore } from '@/enthea/lib/store';
import { EntheaControls } from '@/enthea/components/EntheaControls';

export default function EntheaPage() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current) {
      const s = useStore.getState();
      // Intense DMT-inspired defaults
      s.updateParams({
        mode: 6,
        asc: 0.92,
        dose: 0.82,
        chaos: 0.55,
        cplx: 0.88,
        speed: 1.6,
        sym: 9,
        trail: 0.68,
        palette: 5,
        planform: 0,
        ray: true,
        cine: true,
        flicker: true,
        fhz: 11,
        journey: true,
      });
      Engine.init(canvasRef.current);
    }
    return () => {
      try { Engine.destroy(); } catch {}
    };
  }, []);

  return (
    <div className="relative w-screen h-screen overflow-hidden bg-black">
      <canvas
        ref={canvasRef}
        className="absolute inset-0 w-full h-full block"
      />
      {/* Controls overlay at bottom */}
      <EntheaControls />
    </div>
  );
}
